export class LastConfigRemainingError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'LastConfigRemainingError';
    }
}
